import { useLingui } from '@lingui/react/macro';

import { FiltersSubMenu } from '@/design_system/Filters/FiltersDrawer/FiltersDrawer';
import { FilterRadioGroupWithLabel } from '@/design_system/Filters/FiltersMenu/FilterRadioGroupWithLabel';
import { RadioItem } from '@/design_system/Radio/RadioItem/RadioItem';
import IconFilters from '@/icons/Filters.svg';

import { useFilters } from '../FiltersState';

export const FiltersSortBy = () => {
  const { t } = useLingui();

  const {
    sort: { sort, setSort },
  } = useFilters();

  type SortOption = {
    id: 'reference' | 'statusDueAt';
    label: string;
    ascLabel: string;
    descLabel: string;
  };

  const sortOptions: SortOption[] = [
    {
      id: 'reference',
      label: t({ id: 'shipments.table.column.reference.title', message: 'Reference' }),
      ascLabel: 'A-Z',
      descLabel: 'Z-A',
    },
    {
      id: 'statusDueAt',
      label: t({ id: 'shipments.table.column.step-due-date.title', message: 'Step due date' }),
      ascLabel: t({ id: 'shipments.table.column.step-due-date.asc', message: 'Soonest first' }),
      descLabel: t({ id: 'shipments.table.column.step-due-date.desc', message: 'Latest first' }),
    },
  ];

  const options = sortOptions.map(({ id, label, ascLabel, descLabel }) => (
    <FilterRadioGroupWithLabel
      key={id}
      id={id}
      title={t({ id: 'shipments.filters.sort.label', message: 'Sort by' })}
      label={label}
      value={sort.field === id ? sort.order : null}
      onChange={(order: 'asc' | 'desc') => setSort({ field: id, order: order })}
    >
      <RadioItem value="asc" ariaLabel={label}>
        {ascLabel}
      </RadioItem>

      <RadioItem value="desc" ariaLabel={label}>
        {descLabel}
      </RadioItem>
    </FilterRadioGroupWithLabel>
  ));

  const selectedOption = sortOptions?.find((option) => option.id === sort.field);

  return (
    <FiltersSubMenu
      id="sort-by"
      icon={<IconFilters />}
      label={`${t({ id: 'shipments.filters.sort.label', message: 'Sort by' })} (${selectedOption?.label} : ${selectedOption?.[sort.order === 'asc' ? 'ascLabel' : 'descLabel']})`}
      count={0}
    >
      {options}
    </FiltersSubMenu>
  );
};
